/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { NestedEntityType } from './nested-path.helper';

/**
 * The fields a section item can carry its kind in. `type` is the card's own type, while
 * `v3CardType` and `collectionType` describe what a `PLAYLIST` card actually is — an indicator, for
 * instance, arrives as `type: 'PLAYLIST'` with `collectionType: 'PERSONALITY_INDICATOR'`.
 */
export interface ContentEntityTypeSource {
  type?: string;
  v3CardType?: string;
  collectionType?: string;
}

/**
 * Resolves the entity a content card points at, which is what `NestedPathHelper` needs to build its
 * URL. Kept in one place because every surface showing cards (programme, course, collection,
 * callouts, My Hub) has to agree: a mismatch sends the learner to a path nothing routes.
 */
export function resolveContentEntityType(card: ContentEntityTypeSource): NestedEntityType {
  const cardType = card.type?.toUpperCase();
  const subType = (card.v3CardType || card.collectionType)?.toUpperCase();

  if (cardType === 'ASSIGNMENT' || subType === 'ASSIGNMENT') {
    return 'assignment';
  }
  if (cardType === 'EVENT' || subType === 'EVENT') {
    return 'event';
  }
  // Checked before CARD: an assessment can arrive as type CARD with an ASSESSMENT sub-type.
  if (cardType === 'ASSESSMENT' || subType === 'ASSESSMENT') {
    return 'assessment';
  }
  if (cardType === 'CARD') {
    return 'card';
  }
  if (subType === 'PERSONALITY_INDICATOR') {
    return 'indicator';
  }
  if (subType === 'COLLECTION') {
    return 'collection';
  }
  if (subType === 'PROGRAM' || subType === 'MODULE') {
    return 'program';
  }
  return 'course';
}
